<h2 mat-dialog-title class="dialog-title">{{ 'navigation.exit' | transloco }}</h2>
<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-button (click)="cancel()">{{ 'common.cancel' | transloco }}</button>
  <button mat-raised-button (click)="exit()">{{ 'common.confirm' | transloco }}</button>
</mat-dialog-actions>
